<template lang="pug">
div
  v-app-bar.white.elavation-0(app light height="72" :style="'box-shadow: 0 1px 1px 0 rgba(0,0,0,.08) !important; z-index: 12'")
    v-container(fluid :class="$vuetify.breakpoint.mobile ? 'px-0' : 'px-4'" style="max-width: 1600px")
      v-row(no-gutters align="center")
        v-col(cols="3" md="2" sm="2")
          a(v-if="Auth('page', '/admin/clinic/settings')" href="/admin/clinic/settings")
            v-icon $yzi-yezza-icon
          v-icon(v-else) $yzi-yezza-icon
        v-col(cols="6" md="8" sm="8")
          div.d-flex.align-center.justify-center
            v-menu(v-if="$vuetify.breakpoint.smAndDown")
              template(v-slot:activator="{ on }")
                div.text-center(v-on="on" style="width: 100%")
                  .px-4.py-2
                    a.text-sm.font-semibold.capitalize.no-underline.neutral700--text {{ $store.state.ui.currentNavbarTitle }}
                  .bar-active
              v-list(nav dense)
                v-list-item-group
                  template(v-for="(menuTab, index) in menuTabs")
                    v-list-item
                      v-list-item-title
                        router-link(:to="menuTab.to" v-slot="{ href, route, navigate, isActive, isExactActive }" :key="'menutab'+ index")
                          .font-semibold.text-md.px-3.py-2.mb-2(@click="navigate") {{ menuTab.title }}
            template(v-else)
              div(v-for="(menuTab, index) in menuTabs")
                router-link(:to="menuTab.to" v-slot="{ href, route, navigate, isActive, isExactActive }" :key="'menutab'+ index")
                  div
                    .px-4.py-2
                      a.text-sm.font-semibold.capitalize.no-underline(:href="href" @click="navigate" :class="isActive ? '' : 'neutral500--text'") {{ menuTab.title }}
                    .bar-active(v-if="isActive")
        v-col(cols="3" md="2" sm="2")
          div.d-flex.align-center.justify-end
            //- Consultation Details Height Adjustment
            //- v-menu(v-if="isConsultationDetailsPage" offset-y left rounded="lg" :close-on-content-click="false")
              template(v-slot:activator="{ on }")
                v-icon.mr-4(v-on="on" size=20) mdi-tune
              v-card.pa-4.text-center(min-width="200")
                .text-md.font-semibold Height adjustment
                v-divider.my-4
                .mb-4
                  .text-sm.mb-1.font-semibold Patient history
                  .d-flex.align-center.justify-center
                    v-btn(icon @click="$store.commit('ui/setConsultationPatientHistoryHeightAdjustment', -5)")
                      v-icon mdi-minus-circle
                    v-spacer
                    div {{ patientHistoryHeightAdjustment }}
                    v-spacer
                    v-btn(icon @click="$store.commit('ui/setConsultationPatientHistoryHeightAdjustment', 5)")
                      v-icon mdi-plus-circle
                .mb-4
                  .text-sm.mb-1.font-semibold Treatment table
                  .d-flex.align-center.justify-center
                    v-btn(icon @click="$store.commit('ui/setConsultationTreatmentTableHeightAdjustment', -5)")
                      v-icon mdi-minus-circle
                    v-spacer
                    div {{ treatmentTableHeightAdjustment }}
                    v-spacer
                    v-btn(icon @click="$store.commit('ui/setConsultationTreatmentTableHeightAdjustment', 5)")
                      v-icon mdi-plus-circle
                div
                  .text-sm.mb-1.font-semibold Visit note
                  .d-flex.align-center.justify-center
                    v-btn(icon @click="$store.commit('ui/setConsultationVisitNoteHeightAdjustment', -10)")
                      v-icon mdi-minus-circle
                    v-spacer
                    div {{ visitNoteHeightAdjustment }}
                    v-spacer
                    v-btn(icon @click="$store.commit('ui/setConsultationVisitNoteHeightAdjustment', 10)")
                      v-icon mdi-plus-circle
            //- Display size
            v-menu(offset-y left attach rounded="lg")
              template(v-slot:activator="{ on }")
                v-btn.mr-4(outlined small height="32" color="neutral500" v-on="on")
                  v-icon(left size="18") mdi-monitor-screenshot
                  .text-xs.font-semibold.normal-case {{ getSizeText(selectedSize) }}
              v-list(dense)
                v-list-item-group(v-model="selectedSize")
                  v-list-item(v-for="size in sizes" :key="size.value" :value="size.value" :disabled="selectedSize === size.value")
                    v-list-item-content
                      v-list-item-title.text-sm.neutral700--text {{ size.text }}
            //- Account
            v-menu(offset-y left attach rounded="lg" min-width=200)
              template(v-slot:activator="{ on }")
                v-avatar.cursor-pointer(color="#F2F4F7" size=40 v-on="on")
                  v-icon(size=24 color="primary") $yzi-user-01
              v-list.text-sm.py-0
                v-list-item
                  .py-3
                    .text-sm.font-semibold {{ member.user.first_name }}
                    .text-sm.neutral500--text {{ isClinic ? getMemberRole(member.roles) : member.role }}
                v-divider.basic300
                v-list-item(@click="redirectTo('/admin/clinic/settings/account')")
                  v-icon.mr-2(color="primary" size=16) $yzi-user-01
                  .text-sm.font-medium {{ $t('account_settings') }}
                v-list-item(v-if="Auth('page', '/admin/clinic/settings')" @click="redirectTo('/admin/clinic/settings')")
                  v-icon.mr-2(color="primary" size=16) $yzi-medical-square
                  .text-sm.font-medium {{ $t('clinic_management') }}
                v-divider.basic300
                v-list-item(:href="logoutUrl()")
                  v-icon.mr-2(color="primary" size=16) $yzi-log-out-01
                  .text-sm.font-medium {{ $t('log_out') }}

</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'AppTopBar',
  props: ['menu'],
  data: () => ({
    sizes: [
      { text: 'X-Large', value: 'x-large' },
      { text: 'Large', value: 'large' },
      { text: 'Medium', value: 'medium' },
      { text: 'Small', value: 'small' },
      { text: 'X-Small', value: 'x-small' },
      { text: 'XX-Small', value: 'xx-small' },
    ]
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapState('ui', ['hasNewFeature', 'currentTopBarItems']),
    ...mapState('subscriptions', ['genesData', 'isReady']),
    ...mapGetters({
      patientHistoryHeightAdjustment: 'ui/getConsultationPatientHistoryHeightAdjustment',
      treatmentTableHeightAdjustment: 'ui/getConsultationTreatmentTableHeightAdjustment',
      visitNoteHeightAdjustment: 'ui/getConsultationVisitNoteHeightAdjustment',
      displaySize: 'ui/getDisplaySize',
      company: 'getCompany'
    }),
    menuTabs () {
      if (this.genesData && this.genesData.length > 0 && this.isReady) {
        if (this.company?.genes?.find(gene => gene.feature === 'group_management')) {
          return this.groupClinic()
        } else if (this.genesData?.find(g => g.feature === 'YZ_CLINIC' || g.feature === 'YZ_CMS')) {
          return this.clinicOsNavbar()
        } 
      } else if (this.currentTopBarItems) {
        return this.currentTopBarItems
      }
      return []
    },
    isClinic () {
      return this.genesData?.find(g => g.feature === 'YZ_CLINIC' || g.feature === 'YZ_CMS')
    },
    selectedSize: {
      get () {
        return this.displaySize
      },
      set (val) {
        if (val) {
          this.$store.commit('ui/setDisplaySize', val)
        }
      }
    },
    isConsultationDetailsPage () {
      return this.$route?.name === 'ClinicConsultationDetails'
    }
  },
  created () {
    this.getScrollbarWidth()
  },
  methods: {
    clinicOsNavbar () {
      const menu = []
      if (this.Auth('page', '/admin/clinic/registration')) {
        menu.push({ id: 'registration', to: '/admin/clinic/registration', title: this.$t('registration')})
      }
      if (this.Auth('page', '/admin/clinic/appointment')) {
        menu.push({ id: 'appointment', to: '/admin/clinic/appointment', title: this.$t('appointment')})
      }
      if (this.Auth('page', '/admin/clinic/consultation')) {
        menu.push({ id: 'consultation', to: '/admin/clinic/consultation', title: this.$t('consultation')})
      }
      if (this.Auth('page', '/admin/clinic/review') && !this.Auth('page', '/admin/clinic/marketing')) {
        menu.push({ id: 'review', to: '/admin/clinic/review', title: this.$t('reviews')})
      }
      if (this.Auth('page', '/admin/clinic/panels/claims')) {
        menu.push({ id: 'panels', to: '/admin/clinic/panels', title: this.$t('panel.panel_claims')})
      }
      if (this.Auth('page', '/admin/clinic/insight')) {
        menu.push({ id: 'insight', to: '/admin/clinic/insights', title: this.$t('insight')})
      }
      if (this.Auth('page', '/admin/clinic/purchase-hub')) {
        menu.push({ id: 'purchaseHub', to: '/admin/clinic/purchase-hub', title: 'Purchase hub' })
      }
      if (this.Auth('page', '/admin/clinic/marketing')) {
        menu.push({ id: 'purchaseHub', to: { name: 'ClinicMarketing', params: { reset: true } }, title: 'Marketing' })
      }
      if (this.$store.state.ui.currentTopBarItems !== menu) {
        this.$store.commit('ui/setCurrentTopBarItems', menu)
      }
      return menu
    },
    groupClinic () {
      const menu = []
     
        menu.push({ id: 'lead', to: '/admin/clinic/leads', title: 'Lead'})
        menu.push({ id: 'patient', to: '/admin/clinic/grouppatients', title: 'Patient'})
        menu.push({ id: 'segment', to: '/admin/clinic/segments', title: 'Segment'})
      
      if (this.$store.state.ui.currentTopBarItems !== menu) {
        this.$store.commit('ui/setCurrentTopBarItems', menu)
      }
      return menu
    },
    switchCompany () {
      if (this.$subdomain) {
        document.location.href = `https://app.${process.env.VUE_APP_BASE_DOMAIN}/companies`
      } else {
        this.$router.push('/companies')
      }
    },
    getMemberRole (roles) {
      if (roles.length > 2) {
        return `${this.getClinicRole(roles[0])} and ${roles.length - 1} more`
      } else if (roles.length > 1) {
        return roles.map(m => this.getClinicRole(m)).join(', ')
      } else {
        return this.getClinicRole(roles[0])
      }
    },
    getClinicRole (role) {
      switch (role) {
        case 'Admin':
          return 'Admin'
        case 'Salesperson':
          return 'Clinic Assistance'
        case 'Agent':
          return 'Doctor'
        case 'Bookkeeper':
          return 'Finance'
        default:
          return role
      }
    },
    getSizeText (size) {
      let selectedSize = this.sizes?.find(f => f.value === size)
      if (selectedSize) {
        return selectedSize.text
      }
      return '-'
    },
    getScrollbarWidth() {
      // Create a temporary div element
      const div = document.createElement('div')

      // Apply styles to force a scrollbar
      div.style.position = 'absolute'
      div.style.top = '-9999px' // Move it off-screen
      div.style.width = '100px'
      div.style.height = '100px'
      div.style.overflow = 'scroll'

      // Append the element to the body
      document.body.appendChild(div)

      // Calculate the scrollbar width
      const scrollbarWidth = div.offsetWidth - div.clientWidth

      // Remove the temporary element
      document.body.removeChild(div)

      this.$store.commit('ui/setScrollbarWidth', scrollbarWidth)
    },
    redirectTo (route) {
      this.$router.push(route).catch(()=>{})
    },
    logoutUrl () {
      let link = '/signout'
      if (this.member.username) {
        link += '?username=true'
      }
      return link
    }
  }
}
</script>

<style lang="scss" scoped>
.bar-active {
  height: 2px;
  width: 24px;
  margin: auto;
  margin-top: -2px;
  background-color: #333;
}
</style>
